import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { StepCard } from "@miezmission/ui";
import type { RoutineStep } from "@miezmission/shared-types";

const mockSteps: RoutineStep[] = [
  {
    id: "step-1",
    routineId: "routine-1",
    order: 1,
    title: "Aufwachen & Strecken",
    description: "Morgengymnastik für einen guten Start",
    durationMinutes: 5,
    emoji: "🌅",
  },
  {
    id: "step-2",
    routineId: "routine-1",
    order: 2,
    title: "Zähne putzen",
    description: "Zweimal täglich, zwei Minuten lang",
    durationMinutes: 3,
    emoji: "🦷",
  },
  {
    id: "step-3",
    routineId: "routine-1",
    order: 3,
    title: "Frühstück",
    description: "Gesundes Frühstück essen",
    durationMinutes: 15,
    emoji: "🥣",
  },
];

export function RoutinePage(): React.ReactElement {
  const { routineId } = useParams<{ routineId: string }>();
  const [completedSteps, setCompletedSteps] = useState<Set<string>>(new Set());

  const handleComplete = (stepId: string): void => {
    setCompletedSteps((prev) => new Set([...prev, stepId]));
  };

  const allDone = completedSteps.size === mockSteps.length;

  return (
    <div className="min-h-screen p-6 flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <Link to="/" className="text-purple-600 hover:text-purple-800 font-medium">
          ← Zurück
        </Link>
      </div>

      <h1 className="text-2xl font-bold text-gray-800">
        Morgenroutine {routineId != null ? `#${routineId}` : ""}
      </h1>

      <div className="space-y-3">
        {mockSteps.map((step) => (
          <StepCard
            key={step.id}
            step={step}
            isCompleted={completedSteps.has(step.id)}
            onComplete={handleComplete}
          />
        ))}
      </div>

      {allDone && (
        <div className="mt-4 p-4 bg-green-50 border-2 border-green-300 rounded-2xl text-center">
          <div className="text-4xl mb-2">🎉</div>
          <p className="font-semibold text-green-700">Alle Schritte erledigt!</p>
          <p className="text-sm text-green-600">Deine Katze ist begeistert!</p>
        </div>
      )}
    </div>
  );
}
